module.exports = __webpack_public_path__ + "media/images/front/advisory-lp/bg_title-86112cb1770aa8883a2c64fc10392378.png";